import React, { useState } from 'react'
import { LuChevronLeft, LuChevronRight } from 'react-icons/lu'

import styles from './ConflictTaskSlider.module.css'
import { AssignVehicleTaskDetails } from './AssignVehicleDetails'
import { TaskDefinition } from '../../types/task'

interface ConflictTaskSliderProps {
  tasks: TaskDefinition[]
}

export const ConflictTaskSlider: React.FC<ConflictTaskSliderProps> = ({ tasks }) => {
  const [currentIndex, setCurrentIndex] = useState(0)

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? tasks.length - 1 : prev - 1))
  }

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === tasks.length - 1 ? 0 : prev + 1))
  }

  if (tasks.length === 0) {
    return null
  }

  return (
    <div className={styles.sliderContainer} data-testid="conflict-task-slider">
      <button
        className={styles.navButton}
        onClick={handlePrev}
        disabled={tasks.length <= 1}
        aria-label="Previous task"
      >
        <LuChevronLeft size={24} />
      </button>

      <div className={styles.sliderContent}>
        <div
          className={styles.sliderWrapper}
          data-testid="conflict-task-slider-wrapper"
          style={{
            width: `${tasks.length * 100}%`,
            transform: `translateX(-${(currentIndex * 100) / tasks.length}%)`,
          }}
        >
          {tasks.map((displayTask, index) => (
            <div
              key={displayTask.id || index}
              className={styles.slide}
              style={{ width: `${100 / tasks.length}%` }}
            >
              <AssignVehicleTaskDetails displayTask={displayTask} showStatus={false} />
            </div>
          ))}
        </div>
      </div>

      <button
        className={styles.navButton}
        onClick={handleNext}
        disabled={tasks.length <= 1}
        aria-label="Next task"
      >
        <LuChevronRight size={24} />
      </button>
    </div>
  )
}
